import { DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs } from 'cerialize';
import { Driver } from './driver';
import { FavoriteLocation } from './favorite-location';
import { PaymentAccount } from './payment-account';
import { OrganizationRiderServiceLevel } from './organization-rider-service-level';
import { RideLimitDetail } from './ride-limit-detail';

export class OrganizationRiderDetail {
  @autoserialize
  organizationId: number;

  @autoserialize
  organizationName: string;

  @autoserialize
  active: boolean;

  @autoserialize
  partnerIdentifier: string;

  @autoserialize
  accessibilityRequirements: string;

  @autoserialize
  createdBy: string;

  @autoserializeAs(Date)
  createdDate: Date;

  @autoserialize
  organizationCode: string;

  @autoserialize
  organizationRiderId: number;

  @autoserialize
  riderId: number;

  @autoserialize
  firstName: string;

  @autoserialize
  lastName: string;

  @autoserialize
  phoneNumber: string;

  @autoserialize
  smsEnabledPhone: boolean;

  @autoserialize
  emailAddress: string;

  @autoserializeAs(Date)
  dateOfBirth: Date;

  @autoserialize
  age: string;

  @autoserialize
  riderOver18: boolean;

  @autoserialize
  riderEmailDeclined: boolean;

  @autoserializeAs(Date)
  riderEmailDeclinedAt: Date;

  @autoserialize
  avatarImage: string;

  @autoserialize
  favoriteDrivers: Array<Driver>;

  @autoserializeAs(FavoriteLocation)
  favoriteLocations: Array<FavoriteLocation>;

  @autoserializeAs(PaymentAccount)
  paymentAccounts: Array<PaymentAccount>;

  @autoserialize
  balance: number;

  @autoserialize
  eligible: boolean;

  @autoserialize
  pcaApproved: boolean;

  @autoserialize
  pcaEligible: boolean;

  @autoserialize
  preferredProviderEnabled: boolean;

  @autoserialize
  organizationRiderServiceLevels: Array<OrganizationRiderServiceLevel>;

  @autoserialize
  riderPaymentAccountEnabled: boolean;

  @autoserialize
  riderAppEnabled: boolean;

  @autoserialize
  rideLimitDetail: RideLimitDetail;

  name: string;

  static OnSerialized(instance: OrganizationRiderDetail, json: any): void {
    if (!isNullOrUndefined(instance.createdDate)) {
      json.createdDate = DateUtil.serializeDate(instance.createdDate);
    }

    if (!isNullOrUndefined(instance.dateOfBirth)) {
      json.dateOfBirth = DateUtil.serializeLocalDate(instance.dateOfBirth);
    }

    if (!isNullOrUndefined(instance.riderEmailDeclinedAt)) {
      json.riderEmailDeclinedAt = DateUtil.serializeDate(instance.riderEmailDeclinedAt);
    }
  }

  static OnDeserialized(instance: OrganizationRiderDetail, json: any): void {
    if (!isNullOrUndefined(json['createdDate'])) {
      instance.createdDate = DateUtil.deserializeDate(json['createdDate']);
    }

    if (!isNullOrUndefined(json['firstName']) && !isNullOrUndefined(json['lastName'])) {
      instance.name = `${json['firstName']} ${json['lastName']}`;
    }

    if (!isNullOrUndefined(json['dateOfBirth'])) {
      instance.dateOfBirth = DateUtil.deserializeLocalDate(json['dateOfBirth']);
    }

    if (!isNullOrUndefined(json['riderEmailDeclinedAt'])) {
      instance.riderEmailDeclinedAt = DateUtil.deserializeDate(json['riderEmailDeclinedAt']);
    }
  }
}
